import { refresh } from "#modules/auth/infra/refresh.api";

export class AccessTokenSingleton {
  private static instance: AccessTokenSingleton | null = null;

  private accessToken: string | null;

  private refreshToken: string | null;

  private newTokenPromise?: Promise<string>;

  private constructor() {
    this.accessToken = null;
    this.refreshToken = null;

    this.retrieveAcccessToken();
  }

  public static getInstance(): AccessTokenSingleton {
    if (AccessTokenSingleton.instance === null) {
      AccessTokenSingleton.instance = new AccessTokenSingleton();
    }

    return AccessTokenSingleton.instance;
  }

  public setAccessToken(accessToken: string) {
    this.accessToken = accessToken;
  }

  public getAccessToken(): string | null {
    return this.accessToken;
  }

  public retrieveAcccessToken() {
    const accessTokenApi = localStorage.getItem("accessTokenApi");
    if (accessTokenApi) {
      this.setAccessToken(accessTokenApi);
    }
  }

  public resetToken() {
    this.accessToken = null;
    this.refreshToken = null;
    localStorage.removeItem("accessTokenApi");
  }

  public setRefreshToken(refreshToken: string) {
    this.refreshToken = refreshToken;
  }

  public retrieveNewAccessTokenResponse(): Promise<string> {
    if (this.newTokenPromise === undefined) {
      this.newTokenPromise = this.fetchNewToken()
        .then((data) => {
          this.newTokenPromise = undefined;

          return data;
        })
        .catch((e) => {
          this.newTokenPromise = undefined;
          throw e;
        });
    }

    return this.newTokenPromise;
  }

  private async fetchNewToken(): Promise<string> {
    if (!this.refreshToken) {
      throw new Error("No refresh token");
    }
    const { accessToken, refreshToken } = await refresh(this.refreshToken);
    this.setAccessToken(accessToken);
    this.setRefreshToken(refreshToken);

    return accessToken;
  }
}
